<template>
  <div>
    <!-- 客户邮件 -->
    <baseBreadcrumb :page="$t('message.userEmail')" :menu="$t('message.userInfo')"></baseBreadcrumb>
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.str_time" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.end_time" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!-- 主题关键词 -->
          <div class="item">
            <el-input v-model="datas.keyword" clearable onfocus="this.select()"
              :placeholder="$t('message.topicKeyword')"></el-input>
          </div>
          <!-- 全部账号 -->
          <div class="item">
            <el-select v-model="datas.status" :placeholder="$t('message.status')" clearable>
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 邮件主题 -->
          <li class="flex2">
            {{ $t('message.emailSubject') }}
          </li>
          <!-- 发送人 -->
          <li> {{ $t('message.sender') }}</li>
          <!-- 发送时间 -->
          <li> {{ $t('message.sendingTime') }}</li>
          <!-- 状态-->
          <li> {{ $t('message.status') }}</li>
          <!-- 操作 -->
          <li class="flex05">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 邮件主题 -->
          <li class="flex2">
            {{ item.Subject }}
          </li>
          <!-- 发送人 -->
          <li> </li>
          <!-- 发送时间 -->
          <li> {{ item.insertTime }}</li>
          <!-- 状态-->
          <li> {{ item.status }}</li>
          <!-- 操作 -->
          <li class="flex05">
            <el-button size="mini" type="text" @click="clientEmailLogDetail(item)">
              {{ $t("message.detail") }}
            </el-button>
          </li>
        </ul>
        <!-- 暂无数据 -->
        <div v-if="list == false" class="No_data">{{ $t('message.Nodata') }}</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog :title="detail.Subject" :visible.sync="dialogVisible" width="1350" :close-on-click-modal="false" center>
      <div class="detail">
        <div class="head">
          <div class="email">
            {{ detail.AccountName }}
          </div>
          <div class="time"> {{ detail.insertTime }}</div>
        </div>
        <div class="content" v-html="detail.HtmlContent">

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ $t('message.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {

      datas: {
        user_id: this.$route.query.userID,
        keyword: '',
        status: "",
        str_time: "",
        end_time: "",
      },
      total: 0,
      list: [],
      detail: {},
      dialogVisible: false
    };
  },
  computed: {
    statusList() {
      let list = [
        { label: this.$t('message.notViewed'), value: '0' },
        { label: this.$t('message.viewed'), value: '1' }
      ]
      return list
    }
  },
  created() {
    this.clientEmailLog();
  },
  methods: {
    // 订单列表
    clientEmailLog() {
      this.$api.clienteleApi.clientEmailLog(this.datas).then((res) => {
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.clientEmailLog();
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
        keyword: '',
        status: "",
        str_time: "",
        end_time: "",
      };
      this.$forceUpdate();
      this.clientEmailLog();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.clientEmailLog();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.clientEmailLog();
    },
    //查看详情
    clientEmailLogDetail(item) {
      this.$api.clienteleApi.clientEmailLogDetail({ id: item.id }).then((res) => {
        res.data.HtmlContent = res.data.HtmlContent.replaceAll('br', '<br/>',)
        this.detail = res.data
        this.dialogVisible = true
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: center;

    a {
      color: #fa5058;
      text-decoration: underline;
    }
  }

  .el-icon-sold-out {
    color: #fa5058;
    font-size: 40px;
    cursor: pointer;
  }

  .No_data {
    margin: 20px auto;
    text-align: center;
    font-size: 20px;
  }
}

.head {
  display: flex;
  justify-content: space-between;
}

.content {
  margin-top: 30px;
  max-height: 500px;
  overflow-y: auto;
}
</style>